import { Component, inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog'
import { NgClass } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-confirm',
    template: `
    <div mat-dialog-title class="modal-header" [ngClass]="{ danger: danger }">{{ title }}</div>
    <mat-dialog-content class="p-t-20" [innerHTML]="message"></mat-dialog-content>
    <div mat-dialog-actions align="end" class="modal-footer">
      <button mat-button [mat-dialog-close]="false">Cancel</button>
      <button mat-button [mat-dialog-close]="true" [ngClass]="{ danger: danger }">
        {{ yesText }}
      </button>
    </div>
  `,
    styleUrls: ['./confirm.component.scss'],
    imports: [MatDialogTitle, NgClass, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class ConfirmComponent {
  dialogRef = inject<MatDialogRef<ConfirmComponent>>(MatDialogRef);

  message: string
  title: string
  danger = false
  yesText: string

  constructor() {
    const data = inject(MAT_DIALOG_DATA);

    this.message = data.message ?? ''
    this.title = data.title ?? 'Confirm'
    this.danger = data.danger
    this.yesText = data.yesText ?? 'Yes'
  }
}
